/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { documentsRetrieve } from "../../funcs/documentsRetrieve.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.RetrieveDocumentsRequest$inboundSchema,
};

export const tool$documentsRetrieve: ToolDefinition<typeof args> = {
  name: "documents-retrieve",
  description: `Retrieve documents from an index

Retrieve documents from an index using a query, top_k, and other parameters`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await documentsRetrieve(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
